export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Text = 'text',
  Action = 'action',
  SecondaryAction = 'secondary-action',
  Icon = 'icon',
  Filled = 'filled',
}
